/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Nosessionsyet2Inputs */

const zh_learn_nosessionsyet2 = /** @type {(inputs: Learn_Nosessionsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有学习资源`)
};

const en_learn_nosessionsyet2 = /** @type {(inputs: Learn_Nosessionsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resources yet`)
};

const es_learn_nosessionsyet2 = /** @type {(inputs: Learn_Nosessionsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay recursos`)
};

/**
* | output |
* | --- |
* | "No resources yet" |
*
* @param {Learn_Nosessionsyet2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_nosessionsyet2 = /** @type {((inputs?: Learn_Nosessionsyet2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Nosessionsyet2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_nosessionsyet2(inputs)
	if (locale === "en") return en_learn_nosessionsyet2(inputs)
	return es_learn_nosessionsyet2(inputs)
});
export { learn_nosessionsyet2 as "learn_noSessionsYet" }